import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  colors: {
    main: "#162447",
    secondary: "#1f4068",
    third: "#1b1b2f",
    forth: "#add8e6",
    text: "#ffffff",
    backgroundActive: "black",
    shadowColor: "black",
  },
};
